import { flex } from "@/styles/mixins";
import { Layout, Modal } from "antd";
import styled from "styled-components";

export const LayoutWrap = styled(Layout)`
  .header-logo-text {
    color: #fff;
    opacity: .84;
    font-weight: 600;
    font-size: 24px;
    margin: 18px 0;
    text-align: left;
    padding-left: 20px;
    ${flex('row', 'space-between', 'center')};
    padding: 10px;
  }
  .header-bot-exit-text{
    cursor: pointer;
    font-size: 16px;
    letter-spacing: 2px;
    position: fixed;
    bottom: 20px;
    left: 50px;
  }
  .user-operate{
    min-width: 200px;
    max-width: 200px;
    position: fixed;
    bottom: 20px;
  }
  & .scrollable-menu {
    max-height: 76vh;
    overflow-y: auto;
    scrollbar-color: #7a7a7a transparent;

    & .nav-icon {
      opacity: .7;
      width: 12px;
    }

    & .ant-menu-item,
    & .ant-menu-submenu-title {
      height: 22px !important;
      line-height: 22px !important;
      min-height: 22px !important;
    }
    & .ant-menu-item-selected{
      border-radius: 4px;
    }
  }
`

export const ProfileItem = styled.span`
  > .txt {
    margin-left: 10px;
  }
`

export const ModalWrap = styled(Modal)`
  & .ant-modal-wrap{
    overflow: hidden;
  }
  & .ant-modal-body{
    height: 50vh;
    /* overflow: auto; */
    padding-top: 10px;
    margin-left: -30px;
  }
  & .ant-tabs {
    height: 100%;
    margin-top: -8px;
  }
  & .ant-modal-close{
    top: 13px;
  }
  & .ant-modal-footer{
    margin-top:0;
  }
  & .ant-tree-list{
    max-height: 43vh;
    /* overflow-x: auto; */
    overflow-y: auto;
    overflow-x: hidden;
  }
  & hr{
    width: 102%;
    margin-left: 5px;
    margin-top: -5px;
    color: #d9d9d9;
  }
  & .ant-tabs-content-holder{
    padding-top: 20px;
    border-left: 2px solid #d9d9d9;
  }
  & .ant-tabs-nav-wrap {
    padding-top: 20px;
  }
  & .ant-tabs-tab{
    width: 88%;
    margin-left: 10px !important;
  }
  & .ant-tabs-tab-active {
    background-color: #7a294f;
    width: 88%;
    margin-left: 10px;
    border-radius: 10px;
    & .ant-tabs-tab-btn{
      color: white !important;
    }
  }
  & .ant-upload-list-item {
    border-radius: 50% !important;
  }
  & .ant-upload{
    border-radius: 50% !important;
    cursor: pointer;
    button {
      cursor: pointer;
    }
  }
  & .ant-upload-list-item::before{
    border-radius: 50% !important;
  }
`